import React,{useState,useEffect} from 'react';
import { Form, Input, Button, Select,Card, Row, Col,DatePicker,FormInstance  } from 'antd';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import {  Link, useHistory } from "react-router-dom";
import './profiles-form.css';
import { CandidateType } from '@gtpl/shared-models/common-models';
import {QualificationsService} from '@gtpl/shared-services/masters'
import {ProfilesService} from '@gtpl/shared-services/hrms'
import { QualificationsDto } from '@gtpl/shared-models/masters';
import { ProfilesDto } from '@gtpl/shared-models/hrms';
import { HrmsEmployeeDetailsDto, RolesDto } from '@gtpl/shared-models/masters';
import { HrmsEmpDetService, RolesService } from '@gtpl/shared-services/masters';
import { HrmsEmployeeRequest } from '@gtpl/shared-models/masters';
const { TextArea } = Input;
const { Option } = Select;
export interface ProfilesFormProps {
  profiles:ProfilesDto;
  updateItem: (profiles: ProfilesDto) => void;
  isUpdate:boolean;
  closeForm: () => void;
}

export function ProfilesForm(props: ProfilesFormProps) {
  const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
  const [form] = Form.useForm();
  const history = useHistory();
  const qualificationsService=new QualificationsService();
  const service=new ProfilesService();
  const hrmsEmpDetService = new HrmsEmpDetService();
  const empService = new HrmsEmpDetService();
  let createdUser="";
  if(!props.isUpdate){
    createdUser= localStorage.getItem("createdUser");
  }
  const [qualificationData, setQualificationData] = useState<QualificationsDto[]>([]);
  
  const [isExperience, setIsExperience] = useState<boolean>(false);
  const changeTransferType = (value) => {
    console.log(value)
    if(value === "Experience"){
      setIsExperience(true);
     
    }
    else{
      setIsExperience(false);
     
    }
  }
  
  const [isInternal, setIsInternal] = useState<boolean>(false);
  const Type = (value) => {
    console.log(value)
    if(value === "Internal"){
      setIsInternal(true);
     
    }
    else{
      setIsInternal(false);
     
    }
  }
  const getSelectedEmployeeData = (req) => {
    const request = new HrmsEmployeeRequest(req);
    hrmsEmpDetService.getActiveEmployeesById(request).then(res => {
      if (res.status) {
        form. setFieldsValue ({
         
          interviewerMobieNo: res.data?.mobileNumber,
          
        });
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getAllActiveEmployees = () => {
    empService.getAllActiveEmployees().then(res => {
      if (res.status) {
        setEmployeeData(res.data);
      } else {
        if (res.intlCode) {
          setEmployeeData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setEmployeeData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const saveProfile = (profilesData: ProfilesDto) => {
   
    service.createProfile(profilesData).then(res => {
      if (res.status) {
        AlertMessages.getSuccessMessage('Profiles Created Successfully');
     history.push("/profiles-view")
        onReset();
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
/**
* 
* @param values //Dto values
*/
const saveData = (values: ProfilesDto) => {
    // console.log(values);
    if(props.isUpdate){
      props.updateItem(values);
    }else{
      saveProfile(values);
    }
  
  };


  const onReset=()=>{
    form.resetFields();
  }
useEffect(() => {
    getAllQualifications();
    getAllActiveEmployees();
  }, []);

  /**
   * 
   */
  const getAllQualifications= () => {
    qualificationsService.getAllQualifications().then(res => {
      if (res.status) {
        setQualificationData(res.data);
      } else {
        if (res.intlCode) {
            setQualificationData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setQualificationData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  
  return (
      <>
    <Card title={<span style={{color:'white'}}>Profiles</span>}
        style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate==true?"":<Link to='/profiles-view' ><span style={{color:'white'}} ><Button className='panel_button' >View </Button> </span></Link>} >
          <Form form={form}
           initialValues={props.profiles} 
           name="control-hooks"
            onFinish={saveData}
          layout="vertical"
          >
          <Form.Item name="profileId" style={{display:"none"}} >
            <Input hidden/>
          </Form.Item>
          <Form.Item style={{display:"none"}} name="createdUser"  initialValue={createdUser}>
          <Input hidden/>
        </Form.Item>
        <Row gutter={24}>            
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 5 }} lg={{ span: 5, offset: 5 }} xl={{ span: 5, offset: 5 }} style={{ margin: '1%' }}>
          <Form.Item
                      name="candidateName"
                      label="Candidate Name"
                      rules={[
                        {
                          required: true,
                          message:"It should not be blank"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`
                        }
                        ]}
                      >
                        <Input/>                     
                    </Form.Item>
            </Col> 
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="profileDate"
                      label="Profile Date"
                      rules={[
                        {
                          required: true,
                          message:"It should not be blank"
                        },
                        ]}
                      >
                        < DatePicker
                           style={{ width: '100%' }} format="YYYY-MM-DD"
                           showToday={true}
                        />
                    </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="mobileNumber"
                      label="Mobile Number "
                      rules={[
                        { required: true, message: ' Valid Mobile Number is required' , max:10},
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Don't Allow letters and Spaces`
                        }
                      ]}
                      >
                        <Input/>                      
                    </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="qualification"
                      label="Qualification"
                      rules={[
                        {
                          required: true,
                          message:"It should not be blank"
                        },
                        ]}
                      >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select qualifications"
                        allowClear
                      >
                        {qualificationData.map(dropData => {
                          return <Option key={dropData?.qualificationId}value={dropData.qualificationName}>{dropData.qualificationName}</Option>
                        })}
                      </Select>
                    </Form.Item>
            </Col>
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="skills"
                      label="Skills"
                      rules={[
                        {
                          required: true,
                          message:"It should not be blank"
                        },
                      
                        ]}
                      
                     >
                        <TextArea rows={1}/>                      
                    </Form.Item>
            </Col>              
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="altMobileNumber"
                      label="Alternative Mobile Number"
                      rules={[
                        { required:false, message: ' Valid Mobile Number is required' , max:10},
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Don't Allow letters and Spaces`
                        }
                      ]}
                      >
                        <Input/>
                    </Form.Item>
            </Col> 
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="expectedCTC"
                      label="Expected CTC (In Lacs)"
                      >
                      <Input/>
                    </Form.Item>
            </Col>
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="candidateType"
                      label="Candidate Type"
                      // initialValue={CandidateType.Experience}
                      rules={[
                        {
                          required: true,
                          message:"It should not be blank"
                        },
                        ]}
                  >            
                <Select
                  placeholder="Select Type"
             
                  onSelect={changeTransferType}
                  
                >
                  <Option key={0} value={null}>Select</Option>
                  <Option key={2} value= {'Fresher'}>Fresher</Option>
                  <Option key={1} value= {'Experience'}>Experience</Option>
            
                </Select>                    
              </Form.Item>
            </Col>  
            {/* <Row style={{ display: (isFresher) ? 'block' : 'none' }}> */}
          {isExperience?
           <> <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
              <Form.Item
                name='currentCTC'
                label=" Current CTC(In Lacs) "
                rules={[
                  {
                    pattern: /^[0-9]*$/,
                    message: ` only in numbers `,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col><Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                <Form.Item
                  name='noticePeriod'
                  label="Notice Period(In Days)"
                  rules={[
                    {
                      message: ` only in numbers `,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
             

           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
              <Form.Item
                name='experience'
                label="Experience(In Years) "
                rules={[
                  {
                    pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                    message: `Should contain only numbers.`
                  }
                ]}
              >
                <Input/>
              </Form.Item>
            </Col>   </>:""}        
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name='sourceType'
                      label="Source type"
                      rules={[
                        {
                          required: true,
                          message:"It should not be blank"
                        },
                       
                        ]}
                      
                      >
                      <Select
                      placeholder="Select Type"
                 
                  onSelect={Type}
                  
                >
                         
                  <Option key={0} value={null}>Select</Option>
                  <Option key={1} value= {'Internal'}>Internal</Option>
                <Option key={2} value= {'Direct'}>Direct</Option>
                </Select>                    
                    
                    </Form.Item>
            </Col>
            {isInternal?
          <><Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                      name="referredBy"
                      label="Reference By"
                      >
                      
                <Select
                placeholder="Select Employee Name"
                onChange={getSelectedEmployeeData}
              >
                <Option key={0} value={null}> Select Employee Code</Option>
                {employeeData.map((employee) => {
                  return <Option key={employee.employeeId} value={employee.employeeId}>{employee.employeeName}</Option>
                })}
              </Select> 
           
                    </Form.Item>
            </Col> 
            </> 
            :""} 
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item  name="remarks" label="Remarks"
            rules={[
             {
          
              pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,              
            } 
          ]}>
                <TextArea rows={2} />
              </Form.Item>
            </Col>
           
            </Row> 
            <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            {(props.isUpdate !== true ) && 
           <Button htmlType="button" style = {{margin: '0 14px'}} onClick={onReset}>
             Reset
           </Button>
            }
          </Col>
            </Row>
          </Form>
      </Card>
        </>
      );
          }
export default ProfilesForm; 
